import React, { useState } from "react";
import "./style.css";
import { Spinner } from "react-bootstrap";
import Input from "../../shared/components/common/input";
import TextArea from "../../shared/components/common/textArea";
import { publishVS } from "../../shared/util/validation";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toastMessage } from "../../shared/components/common/toast";
import { ImageUpload } from "../../shared/util/mediaUpload";
import { PublishBook, DeleteBook } from "../../shared/services/libraryService";
import { setUser } from "../../shared/redux/reducers/userSlice";
import { getWeb3 } from "../../shared/util/getWeb3";
import DigiBook from "../../abis/DigiBook.json";
import BookBaseURL from "../../shared/util/coverPhotoBaseURL";

const Publish = () => {
  const [banner, setBanner] = useState(null);
  const dispatch = useDispatch();
  const [bannerUrl, setBannerUrl] = useState(null);
  const [loader, setLoader] = useState(false);
  const { user } = useSelector((state) => state.root);
  const history = useHistory();
  const handleCover = (e) => {
    let file = e.target.files[0];
    ImageUpload(e, (res) => {
      if (res) {
        const fileImage = URL.createObjectURL(file);
        setBannerUrl(fileImage);
        console.log(res);
        setBanner(res);
      }
    });
  };
  const initialValues = {
    file: null,
    name: "",
    writer: "",
    coverImage: null,
    description: "",
    edition: "",
    numberOfCopies: "",
    price: "",
    type: "Fantasy",
  };
  const handlePublish = async (values, action) => {
    let formData = new FormData();
    formData.append("file", values.file);
    formData.append("bookname", values.name);
    formData.append("writername", values.writer);
    formData.append("coverimage", banner);
    formData.append("description", values.description);
    formData.append("edition", values.edition);
    formData.append("copies", values.numberOfCopies);
    formData.append("price", values.price);
    formData.append("genre", values.type);
    let web3 = await getWeb3(null);
    const networkId = await web3?.eth.net.getId();
    const networkData = DigiBook.networks[networkId];
    if (networkData) {
      setLoader(true);
      const abi = DigiBook.abi;
      const address = networkData.address;
      const contract = new web3.eth.Contract(abi, address);
      PublishBook(user?.token, formData)
        .then(async (res) => {
          if (res.statusText === "OK") {
            const x = BookBaseURL + res.data.file;
            try {
              await contract.methods
                .publish(x, res.data.copies, res.data._id)
                .send({ from: user?.user?.walletaddress });
              setLoader(false);
              toastMessage("Book Published", "success");
              action.resetForm();
              setBannerUrl(null);
              setBanner(null);
              history.push(`/home/${user?.user?._id}`);
              let resp = {
                ...user,
                books: user?.books + 1,
              };
              dispatch(setUser(resp));
            } catch (err) {
              console.log(err);
              DeleteBook(user?.token, res.data)
                .then((ress) => {
                  if (ress.statusText === "OK") {
                    setLoader(false);
                    toastMessage(err.message, "error");
                    action.resetForm();
                    setBannerUrl(null);
                    setBanner(null);
                  }
                })
                .catch((error) => {
                  setLoader(false);
                  console.log(error.message);
                });
            }
          } else {
            action.resetForm();
            setLoader(false);
            toastMessage(res.data, "error");
          }
        })
        .catch((err) => {
          setLoader(false);
          toastMessage(err?.response?.data?.message, "error");
        });
    } else {
      toastMessage("Smart Contract not deployed!", "error");
    }
  };
  return (
    <div className="container" data-aos="fade-up" data-aos-duration="500">
      <h2 className="driptivity-text">Publish your book</h2>
      <p className="driptivity-text">
        Create, curate and manage collections of unique NFTs to share and sell.
      </p>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, action) => handlePublish(values, action)}
        validationSchema={publishVS}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          resetForm,
        }) => (
          <>
            <div className="inner-container">
              <div className="publish-subcontainer">
                <h5>Upload file*</h5>
                <div className="image">
                  <span className="upload-styles">
                    <label htmlFor="file" role="button">
                      <input
                        type="file"
                        name="file"
                        onChange={(e) => {
                          setFieldValue("file", e.target.files[0]);
                        }}
                        id="file"
                      />
                      <img
                        src={require("../../assets/icons/upload.svg").default}
                        className="image-styles"
                      />
                    </label>
                  </span>
                </div>
                {touched.file && errors.file && <ErroMsg msg={errors.file} />}
                {values?.file && (
                  <div className="success">{values?.file.name} selected</div>
                )}
              </div>
              <div className="publish-subcontainer">
                <h5>Book name*</h5>
                <Input value={values.name} onChange={handleChange("name")} />
                {touched.name && errors.name && <ErroMsg msg={errors.name} />}
              </div>
              <div className="publish-subcontainer">
                <h5>Writer name*</h5>
                <Input
                  type="text"
                  value={values.writer}
                  onChange={handleChange("writer")}
                />
                {errors.writer && touched.writer && (
                  <ErroMsg msg={errors.writer} />
                )}
              </div>
              <div className="publish-subcontainer">
                <h5>Cover image*</h5>
                <p>
                  The image will also be used for featuring your book on the
                  home page. 260 x 350 recommended
                </p>
                <div className="banner-image-container">
                  <span className="upload-styles">
                    <label htmlFor="file2" role="button">
                      <input
                        type="file"
                        onChange={(e) => {
                          setFieldValue("coverImage", e.target.files[0]);
                          handleCover(e);
                        }}
                        id="file2"
                        style={{ display: "none" }}
                      />
                      <img
                        src={
                          bannerUrl
                            ? bannerUrl
                            : require("../../assets/icons/uploadCover.svg")
                                .default
                        }
                        className={`${
                          bannerUrl ? "image-styles2" : "image-styles"
                        }`}
                      />
                    </label>
                  </span>
                </div>
                {touched.coverImage && errors.coverImage && (
                  <ErroMsg msg={errors.coverImage} />
                )}
              </div>
              <div className="publish-subcontainer">
                <h5>Description*</h5>
                <TextArea
                  row={5}
                  value={values.description}
                  onChange={handleChange("description")}
                />
                {touched.description && errors.description && (
                  <ErroMsg msg={errors.description} />
                )}
              </div>
              <div className="publish-subcontainer">
                <h5>Edition*</h5>
                <Input
                  value={values.edition}
                  onChange={handleChange("edition")}
                />
                {touched.edition && errors.edition && (
                  <ErroMsg msg={errors.edition} />
                )}
              </div>
              <div className="d-flex flex-row">
                <div className="publish-subcontainer" style={{ width: "50%" }}>
                  <h5>Number of Copies*</h5>
                  <Input
                    type="number"
                    value={values.numberOfCopies}
                    onChange={handleChange("numberOfCopies")}
                  />
                  {touched.numberOfCopies && errors.numberOfCopies && (
                    <ErroMsg msg={errors.numberOfCopies} />
                  )}
                </div>
                <div
                  className="publish-subcontainer ml-5"
                  style={{ width: "50%" }}
                >
                  <h5>Price in USD*</h5>
                  <Input
                    type="number"
                    value={values.price}
                    onChange={handleChange("price")}
                  />
                  {touched.price && errors.price && (
                    <ErroMsg msg={errors.price} />
                  )}
                </div>
              </div>
              <div className="publish-subcontainer" style={{ width: "50%" }}>
                <h5>Type*</h5>
                <select
                  id="cars"
                  value={values.type}
                  role="button"
                  className="selector"
                  onChange={handleChange("type")}
                >
                  <option value="Fantasy">Fantasy</option>
                  <option value="Action">Action</option>
                  <option value="Romantic">Romantic</option>
                  <option value="Thriller">Thriller</option>
                </select>
                {touched.type && errors.type && <ErroMsg msg={errors.type} />}
              </div>
              <a
                href="javascript:void(0)"
                onClick={handleSubmit}
                className="custom-create-btn"
              >
                {loader ? <Spinner animation="grow" size="sm" /> : "Publish"}
              </a>
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};
const ErroMsg = ({ msg }) => {
  return <div className="error4">{msg}</div>;
};
export default Publish;
